import { responseStatus } from '../constants';
import { ApiPaths } from '../helpers/api';
import { DonViResponse, TreeSelectBox } from "../models/donvi/DonVi";
import intance from '../utils/axios';

export const layDanhSachDonVi = async (donViQuanLy: boolean) => {
    var data: Array<TreeSelectBox> = [];
    await intance.get(donViQuanLy ? ApiPaths.donVi.layDS : ApiPaths.donVi.layTatCa)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelect(res.data.duLieu)
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

const convertDataSelect = (data : any) => {
    let chidlrenArr: Array<TreeSelectBox> = [];
    if (data) {
        chidlrenArr = data.map((_item : any) => {
            return {
                value: _item?.id,
                title: _item?.ten,
                children: convertDataSelect(_item?.children),
            }
        })
    }
    return chidlrenArr;
}

export const layDanhSachDonViTreeView = async (isKPI?: boolean) => {
    var data: Array<DonViResponse> = [];
    await intance.get(`${ApiPaths.donVi.layTatCa}?isKPI=${isKPI ?? false}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layDanhSachDonViPhuTrachTreeView = async (loaiPhuTrach?: number) => {
    var data: Array<DonViResponse> = [];
    await intance.get(ApiPaths.donVi.layDsDonViPhuTrach + "?loaiPhuTrach=" + (loaiPhuTrach || 0))
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const LayDSDonViPhuTrachTheoIdNhanVien = async (id: number) => {
    var rs: Array<DonViResponse> = [];
    await intance.get(ApiPaths.donVi.layDSDonViPhuTrachTheoIdNhanVien + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}

export const xoaDonVi = async (id: number) => {
    let rs = false;
    await intance.post(ApiPaths.donVi.xoa + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true;
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layChiTietDonVi = async (id: number) => {
    var data: DonViResponse | null = null;
    await intance.get(ApiPaths.donVi.chitiet + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuDonVi = async (data: any) => {
    await intance.post(ApiPaths.donVi.luu, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
};

export const layDsToanBoDonVi = async () => {
    let data: Array<any> = [];
    await intance.get(ApiPaths.donVi.layDsToanBoDonVi)
        .then((res) => {
            if (res.data.trangThai = responseStatus.thanhCong) {
                data = res.data.duLieu;
            }
            else {
                throw new Error(res.data.thongBao);
            }
        })
    return data;
}
